import { useState, useEffect, useCallback } from "react";
import axios from "axios";

import { useManualOccurrence } from "contexts/register/ManualOccurrence";
import { ReactComponent as MarkerIcon } from "assets/marker.svg";
import { ReactComponent as BeneficiaryIcon } from "assets/beneficiary.svg";
import { ReactComponent as BookIcon } from "assets/product.svg";
import { ReactComponent as Copy } from "assets/copy-one.svg";

import * as S from "./styles";
import { InputMap } from "components/InputMap";
import { Button } from "components/Button";
import { useAuth } from "contexts/authContext";
import { ISuperficialAddressProps } from "interfaces/Address";
import { handleOccurrenceUpdate } from "services/handles/OccurrenceHandles";
import { useQueryClient } from "react-query";

export default function OverviewTab() {
  const { occurrenceToEdit } = useManualOccurrence();
  const {role} = useAuth();
  const policeman =
    occurrenceToEdit.policemen?.[0]?.policeman.user.name ??
    occurrenceToEdit.report?.[0]?.superficialPoliceman?.name;
    const [coordY, setCoordY] = useState(0);
    const [coordX, setCoordX] = useState(0);
    const [address, setAddress] = useState<ISuperficialAddressProps>(
      {} as ISuperficialAddressProps
    );
    const queryClient = useQueryClient()
  async function handleSave() {
    await handleOccurrenceUpdate({
      id: occurrenceToEdit.id,
      coordX: coordX,
      coordY: coordY,
      lastCoordX:coordX,
      lastCoordY:coordY,
      superficialClient: undefined!,
      superficialAddressId:occurrenceToEdit.occurrencesSuperficialAddresses.superficialAddress.id,
      ...address
    }).then(()=>{
      queryClient.invalidateQueries('getOccurrence')

    })
  } 
  function handleCopyAddress(value: string) {
    navigator.clipboard.writeText(value);
  }

  function formatAddress() {
    const superficialAddress =
      occurrenceToEdit?.occurrencesSuperficialAddresses?.superficialAddress;

      if(!superficialAddress) return

    return {
      lat: superficialAddress.coordX!,
      lng: superficialAddress.coordY!,
      formattedsuperficialAddress: `${superficialAddress.street ?? "--"}, ${superficialAddress.number ?? "--"
        }, ${superficialAddress.city ?? "--"}, ${superficialAddress.uf ?? "--"}`,
    };
  }

  return (
    <S.Wrapper>
      <S.Section>
        <S.SectionHeader>
          <p>Protocolo</p>
          <h2>{occurrenceToEdit.protocol}</h2>
        </S.SectionHeader>

        <S.SectionHeader>
          <MarkerIcon width={20} height={20} />
          <h2>Endereço</h2>
        </S.SectionHeader>
        <S.Row>
          <S.AddressesWrapper>
            <S.AddressRow>
              <S.Topic>
                <S.Subtitle>Endereço de origem</S.Subtitle>
                <p data-cy="overview-tab-address">{formatAddress()?.formattedsuperficialAddress}</p>
              <S.InputWrapper>
                <InputMap
                  label={'Endereço'}
                  readonly={role !== 'master'}
                  location={formatAddress()}
                  onCoordsChange={(coords) => {
                    setCoordX(coords.lat);
                    setCoordY(coords.lng);
                  }}
                  onAddressChange={(address) => {
                    setAddress(address);
                  }}
                />
                <Button onClick={()=>{handleSave()}} disabled={role !== 'master'}>Salvar</Button>
              </S.InputWrapper>
              </S.Topic>
            </S.AddressRow>
            {occurrenceToEdit.patrimonialType === 2 && (
                <S.AddressRow>
                  <div>
                    <S.Subtitle>Ultima vez visto em</S.Subtitle>
                    <p>{occurrenceToEdit.lastCoordAddress ?? '--'}</p>
                  </div>
                  <Copy
                    data-cy="overview-copy-button"
                    title="Copiar endereço"
                    onClick={() => handleCopyAddress(occurrenceToEdit.lastCoordAddress ?? '--')}
                  />
                </S.AddressRow>
            )}
          </S.AddressesWrapper>

          <S.Container>
          <S.SectionHeader>
            <BookIcon />
            <h2>Cliente</h2>
          </S.SectionHeader>

          <S.ClientInfoWrapper>
            <S.Topic>
              <S.Subtitle>Nome fantasia</S.Subtitle>
              <p>{occurrenceToEdit.client.tradingName}</p>
            </S.Topic>
            <S.Topic>
              <S.Subtitle>Razão social</S.Subtitle>
              <p>{occurrenceToEdit.client.name}</p>
            </S.Topic>
            <S.Topic>
              <S.Subtitle>CNPJ</S.Subtitle>
              <p>{occurrenceToEdit.client.cnpj}</p>
            </S.Topic>
            <S.Topic>
              <S.Subtitle>E-mail</S.Subtitle>
              <p>{occurrenceToEdit.client.email}</p>
            </S.Topic>
            <S.Topic>
              <S.Subtitle>Nome do proprietário</S.Subtitle>
              <p>{occurrenceToEdit.client.managerName}</p>
            </S.Topic>
            <S.Topic>
              <S.Subtitle>Beneficiário</S.Subtitle>
              <p>
                {
                  occurrenceToEdit.occurrencesSuperficialAddresses
                    .superficialAddress?.superficialClient?.name
                }
              </p>
            </S.Topic>
          </S.ClientInfoWrapper>
          </S.Container>
          {occurrenceToEdit.report && occurrenceToEdit.report.length > 0 && (
            <S.Section>
              <S.SectionHeader>
                <BeneficiaryIcon />
                <h2>Pronta-resposta</h2>
              </S.SectionHeader>

              <S.BeneficiaryInfoWrapper>
                <S.Topic>
                  <S.Subtitle>Nome completo</S.Subtitle>
                  <p>{policeman}</p>
                </S.Topic>
              </S.BeneficiaryInfoWrapper>
            </S.Section>
            )}
        </S.Row>
      </S.Section>

    </S.Wrapper>
  );
}
